import { html } from "lit-element";

export const angles = {
	e: (text = "Nr") => html`
<svg
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="11.519446mm"
   height="5.1726756mm"
   viewBox="0 0 11.519446 5.1726756"
   version="1.1"
   id="svg8">
  <defs
     id="defs2" />
  <g 
     id="layer1"
     transform="translate(-86.844443,-146.24699)">
    <g
       id="g4210"
       transform="matrix(0.26458333,0,0,0.26458333,41.23362,45.545404)">
      <path         
         id="path6221-45"
         transform="translate(10,0)" 
         d="m 215.00562,381.50212 -23.90136,10.62528 24.54882,7.08344"
         style="fill:none;stroke:#000000;stroke-width:1.96476209;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
          />
      <text
         id="text4188"
         y="395.2869"
         x="171.33112"
         style="font-style:normal;font-weight:normal;font-size:12.80000019px;line-height:0%;font-family:Arial;-inkscape-font-specification:Arial;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.06666672"
         xml:space="preserve"><tspan
           y="395.2869"
           x="171.33112"
           id="tspan4190"          
           style="font-size:13.86666679px;line-height:1.25;stroke-width:1.06666672">${text}</tspan></text>
    </g>
  </g>
</svg>
`,

	w: (text = "Nr") => html`
<svg
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="12.134811mm"
   height="5.1726756mm"
   viewBox="0 0 12.134811 5.1726756"
   version="1.1"
   id="svg1322"
   >
  <defs
     id="defs1316" />
  <g
     id="layer1"
     transform="translate(-33.998075,-133.39581)">
    <g
       id="g4205"
       transform="matrix(0.26458333,0,0,0.26458333,8.2926252,32.380309)">
      <path 
         id="path6221-1"
         d="M 98.074253,400.44345 121.97563,389.81817 97.426807,382.73473"
         style="fill:none;stroke:#000000;stroke-width:1.96476209;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
          />
      <text
         id="text4201"
         y="395.2869"
         x="128.19019"
         style="font-style:normal;font-weight:normal;font-size:12.80000019px;line-height:0%;font-family:Arial;-inkscape-font-specification:Arial;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.06666672"
         xml:space="preserve"><tspan
           y="395.2869"
           x="128.19019"
           id="tspan4203" 
           style="font-size:13.86666679px;line-height:1.25;stroke-width:1.06666672">${text}</tspan></text>
    </g>
  </g>
</svg>
`,

	s: (text = "Nr") => html`
<svg 
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="5.1726732mm"
   height="10.511679mm"
   viewBox="0 0 5.1726732 10.511679"
   version="1.1"
   id="svg8"  
  >
  <defs
     id="defs2" />
  <g    
     id="layer1"
     transform="translate(-43.526763,-145.84535)">
    <g
       id="g4255"
       transform="matrix(0.26458333,0,0,0.26458333,-51.065999,9.9683133)">
      <g
         id="g4232">
        <path
           style="fill:none;stroke:#000000;stroke-width:1.96476209;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
           d="m 376.16854,552.36039 -10.62528,-23.90137 -7.08343,24.54882"
           id="path6221-11"           
            />
        <text
           xml:space="preserve"
           style="font-style:normal;font-weight:normal;font-size:12.80000019px;line-height:0%;font-family:Arial;-inkscape-font-specification:Arial;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.06666672"
           x="357.45343"
           y="523.47705"
           id="text4228"><tspan             
             id="tspan4230"
             x="357.45343"
             y="523.47705"
             style="font-size:13.86666679px;line-height:1.25;stroke-width:1.06666672">${text}</tspan></text>
      </g>
    </g>
  </g>
</svg>
`,

	n: (text = "Nr") => html`
<svg
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="5.1726756mm"
   height="10.820534mm"
   viewBox="0 0 5.1726756 10.820534"
   version="1.1"
   id="svg8" 
   >
  <defs
     id="defs2" />
  <g
     id="layer1"
     transform="translate(-102.49104,-145.69092)">
    <g
       id="g4250"
       transform="matrix(0.26458333,0,0,0.26458333,-3.8544357,9.5289097)">
      <path
         id="path6221-76"
         d="m 402.83335,515.54789 10.62528,23.90137 7.08344,-24.54882"
         style="fill:none;stroke:#000000;stroke-width:1.96476209;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
          />
      <text
         id="text4246"
         y="555.5246"
         x="404.95587"
         style="font-style:normal;font-weight:normal;font-size:12.80000019px;line-height:0%;font-family:Arial;-inkscape-font-specification:Arial;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.06666672"
         xml:space="preserve"><tspan
           y="555.5246"
           x="404.95587"
           id="tspan4248"
           style="font-size:13.86666679px;line-height:1.25;stroke-width:1.06666672">${text}</tspan></text>
    </g>
  </g>
</svg>
`,

	ne: (text = "Nr") => html`
<svg
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="8.3828268mm"
   height="10.748263mm"
   viewBox="0 0 8.3828268 10.748263"
   version="1.1"
   id="svg8"
>
  <defs
     id="defs2" />
  <g
     id="layer1"
     transform="translate(-99.374063,-156.31039)">
    <g
       id="g4147"
       transform="matrix(0.26458333,0,0,0.26458333,31.586751,97.041572)">
      <path
         id="path6221-8"
         d="m 275.28068,224.41825 -10.91949,23.7684 23.1067,-10.90413"
         style="fill:none;stroke:#000000;stroke-width:1.96476209;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
          />
      <text
         id="text4143"
         y="264.6315"
         x="255.14777"
         style="font-style:normal;font-weight:normal;font-size:12.80000019px;line-height:0%;font-family:Arial;-inkscape-font-specification:Arial;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.06666672"
         xml:space="preserve"><tspan
           y="264.6315"
           x="255.14777"
           id="tspan4145"
           style="font-size:13.86666679px;line-height:1.25;stroke-width:1.06666672">${text}</tspan></text>
    </g>
  </g>
</svg>
`,

	nw: (text = "Nr") => html`
<svg
    xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
    width="7.474875mm"
   height="10.948002mm"
   viewBox="0 0 7.474875 10.948002"
   version="1.1"
   id="svg8"
   >
  <defs
     id="defs2" />
  <g
   id="layer1"
     transform="translate(-88.488753,-156.96647)">
    <g
       id="g4156"
       transform="matrix(0.26458333,0,0,0.26458333,40.512625,91.374891)">
      <path
         id="path6221-4"
         d="m 181.76973,259.99789 23.35119,11.78535 -10.04784,-23.49171"
         style="fill:none;stroke:#000000;stroke-width:1.96476209;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
          />
      <text
         id="text4152"
         y="289.28348"
         x="194.75047"
         style="font-style:normal;font-weight:normal;font-size:12.80000019px;line-height:0%;font-family:Arial;-inkscape-font-specification:Arial;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.06666672"
         xml:space="preserve"><tspan
           y="289.28348"
           x="194.75047"
           id="tspan4154"
           style="font-size:13.86666679px;line-height:1.25;stroke-width:1.06666672">${text}</tspan></text>
    </g>
  </g>
</svg>
`,

	se: (text = "Nr") => html`
<svg
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
  width="8.8713236mm"
   height="9.2504539mm"
    viewBox="0 0 8.8713236 9.2504539"
   version="1.1"
   id="svg8"
  >
  <defs
     id="defs2" />
  <g
     id="layer1"
     transform="translate(-110.4691,-135.89263)">
    <g
       id="g4165"
       transform="matrix(0.26458333,0,0,0.26458333,73.66365,51.869437)">
      <path
         id="path6221-7"
         d="m 172.37949,337.82675 -25.24476,-6.8465 14.56856,20.98993"
         style="fill:none;stroke:#000000;stroke-width:1.96476209;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
          />
      <text
         id="text4161"
         y="327.49402"
         x="138.05096"
         style="font-style:normal;font-weight:normal;font-size:12.80000019px;line-height:0%;font-family:Arial;-inkscape-font-specification:Arial;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.06666672"
         xml:space="preserve"><tspan
           y="327.49402"
           x="138.05096"
           id="tspan4163"
           style="font-size:13.86666679px;line-height:1.25;stroke-width:1.06666672">${text}</tspan></text>
    </g>
  </g>
</svg>
`,

	sw: (text = "Nr") => html`
<svg
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="8.9192944mm"
   height="10.070298mm"
   viewBox="0 0 8.9192944 10.070298"
   version="1.1"
   id="svg8"
>
  <defs
     id="defs2" />
  <g
     
     id="layer1"
     transform="translate(-72.647496,-101.46485)">
    <g
       id="g4174"
       transform="matrix(0.26458333,0,0,0.26458333,22.528413,17.767793)">
      <path         
         id="path6221-0"
         d="m 201.832,353.97329 11.26329,-23.60741 -23.26252,10.56761"
         style="fill:none;stroke:#000000;stroke-width:1.96476209;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
          />
      <text
         id="text4170"
         y="326.26138"
         x="208.30905"
         style="font-style:normal;font-weight:normal;font-size:12.80000019px;line-height:0%;font-family:Arial;-inkscape-font-specification:Arial;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.06666672"
         xml:space="preserve"><tspan
           y="326.26138"
           x="208.30905"
           id="tspan4172"
           
           style="font-size:13.86666679px;line-height:1.25;stroke-width:1.06666672">${text}</tspan></text>
    </g>
  </g>
</svg>
`
};
